export const actionTypes = {
    setOrdersToSend: 'SET_ORDERS_TO_SEND',
    clearOrdersToSend: 'CLEAR_ORDERS_TO_SEND',
    acceptOrder : 'ACCEPT_ORDER',
    rejectOrder: 'REJECT_ORDER',
    sendOrder: 'SEND_ORDER',
};
